import {
  StyleSheet
}

from '@react-pdf/renderer';

export const pdfStyles=StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#fff',
    padding: 20,
    fontSize: 11,
    lineHeight: 1.3,
    fontFamily: 'Roboto'
  }

  ,
  title: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
  }

  ,
  subtitle: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 20,
    fontFamily: 'Roboto',
    fontWeight: 400
  }

  ,
  section: {
    marginBottom: 10,
  }

  ,
  articleTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 5,
    fontFamily: 'Roboto',
  }

  ,
  text: {
    fontSize: 11,
    textAlign: 'justify',
    lineHeight: 1.4,
    fontFamily: 'Roboto',
    fontWeight: 400
  }

  ,
  underline: {
    textDecoration: 'underline',
  }

  ,
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 30,
    paddingTop: 20,
  }

  ,
  signatureBox: {
    width: '40%',
    textAlign: 'center',
  }

  ,
  signatureLine: {
    borderBottom: '1 solid black',
    width: '100%',
    height: 20,
    marginTop: 10,
  }
});
